export const resources = {
  EN: {
    translations: {
      'menu.title.courses': 'Courses',
      'menu.title.certificates': 'Certificates',
      'menu.title.overview': 'Overview',
      'menu.title.logout': 'Logout',

      'menu.hoursleft': 'AI agent voice hours left',

      'courses.page.title': 'Choose one of the following Training Courses',
      'courses.page.nocourses': 'There are currently no courses available.',
      'courses.item.deadline': 'Deadline',
      'courses.item.complete': 'Complete',
      'courses.item.completed': 'Completed',
      'courses.page.allcourses': 'All courses',

      'course.page.startquiz': 'Start Quiz',
      'course.page.quizresult': 'Last quiz result',
      'course.page.lastattempt': 'Last attempt',
      'course.page.result': 'Result',
      'course.page.correct': 'Correct',
      'course.page.passed': 'Passed',
      'course.page.notpassed': 'Not Passed',
      'course.page.wrong': 'Wrong',
      'course.page.success': 'Success',
      'course.page.fail': 'Fail',
      'course.page.backtocourse': 'Back to course',
      'course.page.backtosummary': 'Back to summary',

      'course.page.next': 'Next',
      'course.page.overview': 'Overview',
      'course.page.mindmap': 'Mind Map',
      'course.page.coursecontent': 'Course Content',
      'course.page.videotranscription': 'Video Transcription',
      'course.page.testmindmap': 'Test Mind Map',

      'course.page.completeinfo': `You've completed the {course title} course!`,

      'quiz.page.prev': 'Previous Question',
      'quiz.page.next': 'Next Question',
      'quiz.page.finish': 'Finish',
      'quiz.page.question': 'Question',
      'quiz.page.correct': 'Correct',
      'quiz.page.incorrect': 'Incorrect',
      'quiz.page.answer': 'Answer',
      'quiz.page.details': 'Details',

      'quiz.page.congratulations': 'Congratulations!',
      'quiz.page.completeinfo':
        'You’ve completed the quiz. Your results are now ready, and you can review your answers with your AI Trainer!',

      'menu.footer.reserved': 'All rights reserved',
      'menu.footer.terms': 'Terms of Service',
      'menu.footer.termslink': 'https://www.di-trained.com/en/datenschutz',
      'menu.footer.policy': 'Privacy Policy',
      'menu.footer.linked':
        'https://linkedin.com/company/digital-innovation-ag',

      'course.page.instructions': `
  **Instructions:**
  
  - **Read the questions carefully and select the correct answer for each question.**
  - **You can take a break at any time and resume later.**
  - **You can retake the test as many times as you would like.**
  - **The progress bar at the top of the screen will show your progress.**
  - **After completing the quiz by clicking the 'Finish quiz' button, you can view your results immediately.**
  `,
    },
  },
  DE: {
    translations: {
      'menu.title.courses': 'Kurse',
      'menu.title.certificates': 'Zertifikate',
      'menu.title.overview': 'Übersicht',
      'menu.title.logout': 'Abmelden',

      'menu.hoursleft': 'Verbleibende Sprachstunden des KI-Agenten',

      'courses.page.title': 'Wählen Sie einen der folgenden Schulungskurse aus',
      'courses.page.nocourses': 'Derzeit sind keine Kurse verfügbar.',
      'courses.item.deadline': 'Abgabetermin',
      'courses.item.complete': 'Abgeschlossen',
      'courses.item.completed': 'Abgeschlossen',
      'courses.page.allcourses': 'Alle Kurse',

      'course.page.startquiz': 'Quiz starten',
      'course.page.quizresult': 'Letztes Quiz-Ergebnis',
      'course.page.lastattempt': 'Letzter Versuch',
      'course.page.result': 'Ergebnis',
      'course.page.correct': 'Richtig',
      'course.page.passed': 'Bestanden',
      'course.page.notpassed': 'Nicht Bestanden',
      'course.page.wrong': 'Falsch',
      'course.page.success': 'Erfolg',
      'course.page.fail': 'Fehlgeschlagen',
      'course.page.backtocourse': 'Zurück zum Kurs',
      'course.page.backtosummary': 'Zurück zur Zusammenfassung',

      'course.page.next': 'Weiter',
      'course.page.overview': 'Übersicht',
      'course.page.mindmap': 'Mind Map',
      'course.page.coursecontent': 'Kursinhalt',
      'course.page.videotranscription': 'Videotranskript',
      'course.page.testmindmap': 'Test Mind Map',
      'course.page.completeinfo': `Sie haben den Kurs {course title} abgeschlossen!`,

      'quiz.page.prev': 'Vorherige Frage',
      'quiz.page.next': 'Nächste Frage',
      'quiz.page.finish': 'Abschließen',
      'quiz.page.question': 'Frage',
      'quiz.page.correct': 'Richtig',
      'quiz.page.incorrect': 'Falsch',
      'quiz.page.answer': 'Antwort',
      'quiz.page.details': 'Einzelheiten',

      'quiz.page.congratulations': 'Herzlichen Glückwunsch!',
      'quiz.page.completeinfo':
        'Du hast das Quiz abgeschlossen. Deine Ergebnisse sind jetzt verfügbar und du kannst deine Antworten mit deinem KI-Trainer überprüfen!',

      'menu.footer.reserved': 'Alle Rechte vorbehalten',
      'menu.footer.terms': 'Nutzungsbedingungen',
      'menu.footer.termslink': 'https://www.di-trained.com/datenschutz',
      'menu.footer.policy': 'Datenschutzerklärung',
      'menu.footer.linked':
        'https://de.linkedin.com/company/digital-innovation-ag',

      'course.page.instructions': `
  **Anweisungen:**
  
  - **Lesen Sie die Fragen sorgfältig durch und wählen Sie pro Frage die korrekte Antwortmöglichkeit aus.**
  - **Sie können jederzeit eine Pause machen und später fortfahren.**
  - **Sie können den Test so oft wiederholen, wie Sie möchten.**
  - **Der Fortschrittsbalken am oberen Rand des Bildschirms zeigt Ihren Fortschritt an.**
  - **Nachdem Sie das Quiz mit dem Button „Quiz beenden“ abgeschlossen haben, können Sie Ihre Ergebnisse direkt einsehen.**
  `,
    },
  },
};
